import React from 'react';
import APPConstant from "../../common/AppConstants";
import Typography from "@mui/material/Typography";
import { addOpacity } from '../../utils/appHelper';
import { useTheme } from '@mui/material';
function ApprovedProfiles(props) {
    const theme = useTheme();
    return (<>
        {props.currentCoaching && <Typography style={{ color: addOpacity(theme.palette.text.primary, 0.54) }}>{APPConstant.CURRENTLY_NOT_WORKING}</Typography>}
        {!props.currentCoaching && <Typography  style={{ color: addOpacity(theme.palette.text.primary, 0.54) }}>{APPConstant.NA}</Typography>}
    </>
    );
}

export default ApprovedProfiles;